import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about">
      <div className="about__inner">
        <h1>About Saundarryam</h1>
        <h3>"Let us take care of You"</h3>
        <p>
          Saundarryam is a small-batch, handcrafted soap brand rooted in the belief that
          what you put on your skin matters. Every bar we make is crafted with natural
          botanicals, pure essential oils, and a lot of care.
        </p>
        <p>
          We started with one simple product — a rose soap — and a commitment to never
          use harsh chemicals, parabens, or synthetic fragrances. Our soaps are gentle
          on your skin and kind to the planet.
        </p>
        <p>
          Thank you for supporting a small, honest business. Every purchase means the world to us.
        </p>
      </div>
    </div>
  );
}

export default About;